var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "mobile-card",
    [
      _c("template", { slot: "title" }, [
        _c("div", { staticClass: "charge-card-title" }, [
          _vm._v(" " + _vm._s(_vm.item.name) + " ")
        ])
      ]),
      _c(
        "template",
        { slot: "content" },
        _vm._l(_vm.item.details, function(detail, index) {
          return _c("div", { key: index, staticClass: "flex-form-info" }, [
            _c("div", { staticClass: "left" }, [_vm._v(_vm._s(detail.name))]),
            detail.type === "money"
              ? _c(
                  "div",
                  {
                    staticClass: "right link",
                    staticStyle: { color: "#005423" }
                  },
                  [_vm._v(_vm._s(_vm._f("formatMoney")(detail.value)) + " ")]
                )
              : _c("div", { staticClass: "right" }, [
                  _vm._v(_vm._s(detail.value))
                ])
          ])
        }),
        0
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }